/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
    function Vote(param) {
        var _this = this;

        (0, _classCallCheck3["default"])(this, Vote);

        _scope.Feature.EventBus(this);

        this.act_id = param.act_id;
        this.vote = param.vote;
        this.tracker = param.tracker;
        param.vote && (this.vote_id = param.vote.id);

        rop.On('vote_' + this.act_id, function (data) {
            var jsonObj = JSON.parse(data);
            _this.vote_id = jsonObj.vote_id;
            _this.vote = jsonObj;

            if (jsonObj.type === 0) {
                _scope.MsgBus.Pub('Vote.Changed', (0, _stringify2["default"])({ status: 'n', info: '无投票信息', flag: 101 }));
                return;
            }

            _this.Get(function (info) {
                _scope.MsgBus.Pub('Vote.Changed', info);
            });
        });

        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Vote, [{
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                rop.Remove('vote_' + _this2.act_id);

                _scope.MsgBus.UnSubAll('Vote.Changed');
                _scope.MsgBus.UnSub(_this2.destroyKey);
            });
        }
    }, {
        key: 'UnSubVoteTopics',
        value: function UnSubVoteTopics() {
            rop.Remove('vote_' + this.act_id);
        }

        // 获取最新投票信息

    }, {
        key: 'Get',
        value: function Get(cb) {
            var url = _config2["default"].API_DOMAIN + '/?c=activity&a=ajaxGetActVote';
            var param = { vote_id: this.vote_id };

            if (!this.vote_id) {
                cb((0, _stringify2["default"])({ status: 'n', info: '无投票信息', flag: 101 }));
                return;
            }

            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.data = data.vote;
                cbData.info = '获取成功';
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
            };
            Fetcher.PostForm(url, param, callback);
        }

        // 进行投票

    }, {
        key: 'Vote',
        value: function Vote(answer, cb) {
            var _self = this;
            var url = _config2["default"].API_DOMAIN + '/?c=activity&a=ajaxVote';
            var param = {
                vote: (0, _stringify2["default"])(answer),
                act_id: this.act_id
            };

            var callback = function callback(data) {
                data = JSON.parse(data);
                var cbData = {};
                cbData.status = data.status;
                cbData.flag = 100;
                cbData.info = data.msg;
                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));

                // tracker vote
                var tracker = _self.tracker;
                if (data.status === 'y' && tracker && 'function' === typeof tracker.triggerEvent) {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'vote'
                    });
                }
            };

            Fetcher.PostForm(url, param, callback);
        }
    }]);
    return Vote;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Vote.js
 ** module id = 174
 ** module chunks = 1
 **/